import { render, staticRenderFns } from "./event-rules.vue?vue&type=template&id=5d299a78&scoped=true&"
import script from "./event-rules.vue?vue&type=script&lang=js&"
export * from "./event-rules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d299a78",
  null
  
)

export default component.exports